import { Service } from '@/tools'

export class procureOrderService<T extends TProcure.Order> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TProcure.Order}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  // 新增采购单
  add = <K extends T['ApiAdd']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAdd', data)

  /**
   * 功能：供应商发货通知单关联-查询采购单
   * /api/procure/order/v1/queryOrde
   */
  queryOrder = <K extends T['ApiQueryOrder']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiQueryOrder', data)

  /**
   * 功能：供应商发货通知单关联-查询采购单-详情
   * /api/procure/order/v1/queryOrderDetail
   */
  queryOrderDetail = <K extends T['ApiQueryOrderDetail']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiQueryOrderDetail', data)

  /**
   * 模块说明：列表相关接口
   */
  purchasePage = <K extends T['ApiPage']>(data: K['req']): Promise<K['res']['data']> => {
    return this.post2('v1/ApiPage', data)
  }

  /**
   * 模块说明：新增相关接口
   */
  purchaseAddOrder = <K extends T['ApiAdd']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiAdd', data, '操作成功')
  }

  /**
   * 模块说明：详情相关接口
   */
  purchaseDetail = <K extends T['ApiDetail']>(data: K['req']): Promise<K['res']['data']> => {
    return this.post2('v1/ApiDetail', data)
  }

  /**
   * 模块说明：查询商品信息
   */
  purchaseCommodity = <K extends T['ApiCommodity']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiCommodity', data)
  }

  /**
   * 模块说明：采购单-了结
   */
  purchaseEnd = <K extends T['ApiEnd']>(data: K['req']): Promise<K['res']['data']> => {
    return this.post2('v1/ApiEnd', data, '操作成功')
  }

  /**
   * 模块说明：采购单-明细导出
   */
  purchaseExport = <K extends T['ApiExport']>(data: K['req']): Promise<K['res']['data']> => {
    return this.post2('v1/ApiExport', data, 'blob')
  }

  /**
   * 模块说明：回告上传
   */
  importExcel = <K extends T['ApiImportExcel']>(data: K['req']): Promise<K['res']['data']> => {
    return this.post2('v1/ApiImportExcel', data, '操作成功')
  }

  /**
   * 模块说明：回告调整
   */
  purchaseFeedBackAdjustImport = <K extends T['ApiFeedBackAdjustImport']>(data: K['req']): Promise<K['res']['data']> => {
    return this.post2('v1/ApiFeedBackAdjustImport', data, '操作成功')
  }

  /**
   * 模块说明：查询采购单关联单据
   */
  purchaseFeedBackReceipt = <K extends T['ApiReceipt']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiReceipt', data)
  }

  /**
   * 模块说明：销售组列表
   */
  getBusRelList = <K extends T['ApiGetBusRelList']>(data: K['req']): Promise<K['res']['data']> => {
    return this.post2('v1/ApiGetBusRelList', data)
  }

  /**
   * 模块说明：查看批次信息
   */
  batchList = <K extends T['ApiBatch']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiBatch', data)
  }

  /**
   * 模块说明：checkPurchaseContract
   */
  checkPurchaseContract = <K extends T['ApiCheckPurchaseContract']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiCheckPurchaseContract', data)
  }

  /**
   * 模块说明：采购单商品行信息查询
   */
  queryProcureCommodity = <K extends T['ApiQueryProcureCommodity']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiQueryProcureCommodity', data)
  }

  /**
   * 模块说明：根据供应商ID查询采购单信息
   */
  findPurchaseOrdersBySupplierId = <K extends T['ApiFindPurchaseOrdersBySupplierId']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiFindPurchaseOrdersBySupplierId', data)
  }
}
